// @flow

import {
  type UserInputValidationError,
  type UserInputValidatorArgs,
  onlyWhenSupport,
  VALID,
} from '@tectonics/prs/validation';

import { validateColombianCity } from './colombian-city';
import { validateColombianState } from './colombian-state';
import { validateColombianZipcode } from './colombian-zipcode';
import { validateColombianAddress } from './colombian-address';
import { validateColombianDocument } from './colombian-document';
import { validateColombianPhoneNumber } from './colombian-phone-number';
import { validateColombianStreetNumber } from './colombian-street-number';
import { validateColombianDocumentType } from './colombian-document-type';

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'colombianDocument':
      return onlyWhen('field_colombian_document') && validateColombianDocument(userInputValue, userInputValues['colombianDocumentType']);

    case 'colombianDocumentType':
      return onlyWhen('field_colombian_document_type') && validateColombianDocumentType(userInputValue);

    case 'colombianPhoneNumber':
      return onlyWhen('field_colombian_phone_number') && validateColombianPhoneNumber(userInputValue);

    case 'colombianZipcode':
      return onlyWhen('field_colombian_zipcode') && validateColombianZipcode(userInputValue);

    case 'colombianState':
      return onlyWhen('field_colombian_state') && validateColombianState(userInputValue);

    case 'colombianCity':
      return onlyWhen('field_colombian_city') && validateColombianCity(userInputValue);

    case 'colombianAddress':
      return onlyWhen('field_colombian_address') && validateColombianAddress(userInputValue);

    case 'colombianStreetNumber':
      return onlyWhen('field_colombian_street_number') && validateColombianStreetNumber(userInputValue);

    default:
      return VALID;
  }
}
